//根据温度计算饱和压力
function psychro_pvs(t) {
	var psychro_pvs;
	c1 = -5.6745359e3;
	c2 = 6.3925247;
	c3 = -9.6778430e-3;
	c4 = 6.2215701e-7;
	c5 = 2.0747825e-9;
	c6 = -9.4840240e-13;
	c7 = 4.1635019;
	c8 = -5.8002206e3;
	c9 = 1.3914993;
	c10 = -4.8640239e-2;
	c11 = 4.1764768e-5;
	c12 = -1.4452093e-8;
	c13 = 6.5459673;
	var Ta = t + 273.15;
	if (t < 0.0) {
		psychro_pvs = 0.001 * Math.exp(c1 / Ta + c2 + c3 * Ta + c4 * Math.pow(Ta, 2) + c5 * Math.pow(Ta, 3) + c6 * Math.pow(Ta, 4) + c7 * Math.log(Ta));
	} else {
		psychro_pvs = 0.001 * Math.exp(c8 / Ta + c9 + c10 * Ta + c11 * Math.pow(Ta, 2) + c12 * Math.pow(Ta, 3) + c13 * Math.log(Ta));
	}
	return psychro_pvs;
}
//计算水蒸气分压力
function psychro_pv(t, tw, atm) {
	var psychro_pv, d;
	var pvs = psychro_pvs(tw);//该温度下的水蒸气分压力
	var ds = (pvs / (atm - pvs)) * 0.621945;//含湿量
	if (tw <= 0) {
		d = ((2830 - 0.24 * tw) * ds - 1.006 * (t - tw)) / (2830 + 1.86 * t - 2.1 * tw);
		psychro_pv = atm * (d / (0.621945 + d));
	} else {
		d = ((2501 - 2.326 * tw) * ds - 1.006 * (t - tw)) / (2501 + 1.86 * t - 4.186 * tw);
		psychro_pv = atm * (d / (0.621945 + d));
	}
	return psychro_pv;
}
function psychro_pv2(d, atm) {
	return atm * (d / (0.621945 + d));
}
//计算露点温度
function psychro_td(pv) {
	var psychro_td;
	var y = Math.log(pv);
	psychro_td = 6.09 + 12.608 * y + 0.4959 * Math.pow(y, 2);
	if (psychro_td >= 0) psychro_td = 6.54 + 14.526 * y + 0.7389 * Math.pow(y, 2) + 0.09486 * Math.pow(y, 3) + 0.4569 * Math.pow(pv, 0.1984);
	return psychro_td;
}
//根据温度，计算含湿量
function psychro_d(t, tw, atm) {
	var psychro_d;
	var pv = psychro_pv(t, tw, atm);
	psychro_d = 0.621945 * pv / (atm - pv);
	return psychro_d;
}
//根据水蒸气分压力，计算含湿量
function psychro_d_pv(atm, pv) {
	var psychro_d_pv;
	psychro_d_pv = 0.621945 * pv / (atm - pv);
	return psychro_d_pv;
}
//根据温度，湿球温度求焓值
function psychro_h(t, tw, atm) {
	var psychro_h;
	psychro_h = 1.006 * t + psychro_d(t, tw, atm) * (2501 + 1.86 * t);
	return psychro_h;
}
//根据 温度和含湿量求焓值
function psychro_h_d(t, d) {
	var psychro_h_d;
	psychro_h_d = 1.006 * t + d * (2501 + 1.86 * t);
	return psychro_h_d;
}
//根据温度、湿球温度，求相对湿度
function psychro_rh(t, tw, atm) {
	var psychro_rh;
	if (t != tw) psychro_rh = 100 * psychro_pv(t, tw, atm) / psychro_pvs(t);
	else psychro_rh = 100;
	return psychro_rh;
}
//根据温度、湿球温度，求  （应该跟湿度有关的比值）
function psychro_v(t, tw, atm) {
	var psychro_v;
	psychro_v = 0.287042 * (t + 273.15) * (1 + 1.607858 * psychro_d(t, tw, atm)) / atm;
	return psychro_v;
}
//根据焓值求湿球温度
//原理，等焓线与100%相对湿度线的交点（这个算法太低级了……TODO:）
function psychro_tw(h, atm) {
	var tw;
	var pvs, ds;
	var dt, hmid, tlow, thigh;
	var j = 1;
	var acc = 0.0001;
	tlow = -100;
	thigh = h / 1.006;
	for (j = 1; j < 100; j++) {
		dt = (thigh - tlow) * 0.5;
		tw = tlow + dt;
		pvs = psychro_pvs(tw);
		ds = psychro_d_pv(atm, pvs);
		hmid = psychro_h_d(tw, ds);
		if ((h - hmid) > 0.0) tlow = tw;
		else thigh = tw;
		if (Math.abs(dt) < acc) break;
	}
	return tw;
}
function psychro_t(d, h) {
	return (h - 2501 * d) / (1.006 + 1.84 * d);
}
//0干球温度t;1湿球温度tw;2相对湿度RH;3露点温度td;4含湿量d;5比焓h;6水蒸气分压力pv
//0干球温度t;1湿球温度tw;
function Calcu_01(t, tw, atm) {
	var rh;
	var pv;
	var td;
	var d;
	var h;
	var v;
	rh = psychro_rh(t, tw, atm);
	pv = psychro_pv(t, tw, atm);
	td = psychro_td(pv);
	d = psychro_d(t, tw, atm);
	h = psychro_h(t, tw, atm);
	v = psychro_v(t, tw, atm);
	if (rh > 100 || rh < 0) rh = "NaN";
	//else rh= rh.toFixed(2);
	if (td > tw || td > t) td = "NaN";
	//else td= td.toFixed(2);
	//d = (d * 1000).toFixed(2);
	//h = h.toFixed(2);
	//pv = pv.toFixed(4);
	//v = v.toFixed(4);
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
//0干球温度t;2相对湿度RH;
function Calcu_02(t, rh, atm) {
	var pvs;
	var tw;
	var pv;
	var td;
	var d;
	var h;
	var v;
	pvs = psychro_pvs(t);
	pv = rh / 100.0 * pvs;
	td = psychro_td(pv);
	d = psychro_d_pv(atm, pv);
	h = psychro_h_d(t, d);
	tw = psychro_tw(h, atm);
	v = psychro_v(t, tw, atm);
	if (tw > t) tw = "NaN";
	if (td > t) td = "NaN";
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
//0干球温度t;3露点温度td;
function Calcu_03(t, td, atm) {
	var pvs;
	var tw;
	var pv;
	var rh;
	var d;
	var h;
	var v;
	pvs = psychro_pvs(td);
	d = psychro_d_pv(atm, pvs);
	h = psychro_h_d(t, d);
	tw = psychro_tw(h, atm);
	rh = psychro_rh(t, tw, atm);
	pv = psychro_pv(t, tw, atm);
	v = psychro_v(t, tw, atm);
	if (tw > t) tw = "NaN";

	if (rh > 100 || rh < 0) rh = "NaN";
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
//0干球温度t;4含湿量d
function Calcu_04(t, d, atm) {
	var tw;
	var pv;
	var rh;
	var td;
	var h;
	var v;
	h = psychro_h_d(t, d);
	tw = psychro_tw(h, atm);
	rh = psychro_rh(t, tw, atm);
	pv = psychro_pv(t, tw, atm);
	v = psychro_v(t, tw, atm);
	td = psychro_td(pv);
	if (tw > t) tw = "NaN";
	if (rh > 100 || rh < 0) rh = "NaN";

	if (td > tw || td > t) td = "NaN";

	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
//0干球温度t;5比焓h;
function Calcu_05(t, h, atm) {
	var tw;
	var pv;
	var rh;
	var td;
	var d;
	var v;
	tw = psychro_tw(h, atm);
	rh = psychro_rh(t, tw, atm);
	pv = psychro_pv(t, tw, atm);
	td = psychro_td(pv);
	d = psychro_d(t, tw, atm);
	v = psychro_v(t, tw, atm);
	if (tw > t) tw = "NaN";
	//else t_wb.value = tw.toFixed(2);
	if (rh > 100 || rh < 0) rh = "NaN";
	//else relat_hum.value = rh.toFixed(2);
	if (td > tw || td > t) td = "NaN";
	//else t_dp.value = td.toFixed(2);
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
////0干球温度t;6水蒸气分压力pv
function Calcu_06(t, pv, atm) {
	var tw;
	var d;
	var rh;
	var td;
	var h;
	var v;
	td = psychro_td(pv);
	d = psychro_d_pv(atm, pv);
	h = psychro_h_d(t, d);
	tw = psychro_tw(h, atm);
	rh = psychro_rh(t, tw, atm);
	v = psychro_v(t, tw, atm);
	if (tw > t) tw = "NaN";
	//else t_wb.value = tw.toFixed(2);
	if (rh > 100 || rh < 0) rh = "NaN";
	//else relat_hum.value = rh.toFixed(2);
	if (td > t) td = "NaN";
	//else t_dp.value = td.toFixed(2);
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
var FunX;
function f(x1) {
	return eval(FunX);
}
function Itera_1(a, b, x2, y, atm, psychro_y) {
	var eps = 0.000001;
	var x1;
	var n = 0;
	FunX = psychro_y + "(x1," + x2 + "," + atm + ")" + "-" + y;
	do {
		x1 = (a + b) / 2;
		n++;
		if (f(a) * f(x1) < 0) {
			b = x1;
		} else {
			a = x1;
		}
	} while (Math.abs(b - a) > eps);
	x1 = (a + b) / 2;
	return x1;
}
function Itera_2(a, b, y, psychro_y) {
	var eps = 0.000001;
	var x1;
	var n = 0;
	FunX = psychro_y + "(x1)" + "-" + y;
	do {
		x1 = (a + b) / 2;
		n++;
		if (f(a) * f(x1) < 0) {
			b = x1;
		} else {
			a = x1;
		}
	} while (Math.abs(b - a) > eps);
	x1 = (a + b) / 2;
	return x1;
}
//湿球温度tw	相对湿度RH
function Calcu_12(tw, rh, atm) {
	var t = Itera_1(- 100, 200, tw, rh, atm, "psychro_rh");
	if (t < tw) t = "NaN";
	else {
		return Calcu_01(t, tw, atm);
	}
	return { t: t, tw: tw, rh: rh, td: "NaN", d: "NaN", h: "NaN", pv: "NaN" }
}
function Calcu_13(tw, td, atm) {
	if (td > tw) alert("错误：露点温度不可大于湿球温度！");
	var pv = Itera_2(0.00000001, atm, td, "psychro_td");
	var t = Itera_1(- 100, 200, tw, pv, atm, "psychro_pv");
	if (t < tw) t = "NaN";
	else {
		return Calcu_01(t, tw, atm);
	}
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
function Calcu_14(tw, d, atm) {
	var t = Itera_1(- 100, 200, tw, d, atm, "psychro_d");
	if (t < tw) {
		t = "NaN";
		alert("Calcu_14(" + tw + "," + d + ")-" + t + "<" + tw + "警告：t<tw")
		return false;
	}
	else {
		return Calcu_01(t, tw, atm);
	}
	//return {t:t,tw:tw,rh:"NaN",td:"NaN",d:d,h:"NaN",pv:"NaN"}
}
function Calcu_16(tw, pv, atm) {
	var t = Itera_1(- 100, 200, tw, pv, atm, "psychro_pv");
	if (t < tw) t = "NaN";
	else {
		return Calcu_01(t, tw, atm);
	}
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
function Calcu_23(rh, td, atm) {
	var t;
	var pv;
	var pvs;
	pv = Itera_2(0.00000001, atm, td, "psychro_td");
	pvs = pv / rh * 100;
	t = Itera_2(- 100, 200, pvs, "psychro_pvs");
	if (t < td) t = "NaN";
	else {
		return Calcu_02(t, rh, atm);
	}
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
function Calcu_24(rh, d, atm) {
	var t;
	var pv;
	var pvs;
	pv = d / (0.621945 + d) * atm;
	pvs = pv / rh * 100;
	t = Itera_2(- 100, 200, pvs, "psychro_pvs");

	//var res=Calcu_02(t, rh, atm);
	var res = Calcu_04(t, d, atm);
	//console.log("Calcu_24:",rh,d,res)
	return res;
}
function Calcu_25(rh, h, atm) {

	var tw = psychro_tw(h, atm);//tw算的不准确
	return Calcu_12(tw, rh, atm);
}
function Calcu_26(rh, pv, atm) {
	var td = psychro_td(pv);
	return Calcu_23(rh, td, atm);
}
function Calcu_35(td, h, atm) {
	var tw = psychro_tw(h, atm);//tw算的不准确
	if (tw < td) tw = "NaN";
	else {
		return Calcu_13(tw, td, atm);
	}
	return { t: t, tw: tw, rh: rh, td: td, d: d, h: h, pv: pv }
}
function Calcu_45(d, h, atm) {
	var t = psychro_t(d, h);//
	//console.log("Calcu_45.tw:",d,h,t)
	return Calcu_04(t, d, atm);
	//var tw = psychro_tw(h, atm);//tw算的不准确
	//console.log("Calcu_45.tw:",d,h,tw)
	//return Calcu_14(tw, d, atm);
}
function Calcu_56(h, pv, atm) {
	var tw = psychro_tw(h, atm);//tw算的不准确
	return Calcu_16(tw, pv, atm);
}

/* 补充：增加空气处理过程的计算函数 */
//计算热湿度比值
function calcE(Q, W) {
	if (W != 0) {
		return Q / W;
	} else {
		return Number.POSITIVE_INFINITY;//无穷大
	}
}
//送风状态点(室内状态点，温差【区分正负号】,焓湿比)
function calcOstatus(nStatus, e, dT, atm) {
	var tn = nStatus.t;
	var dn = nStatus.d;
	var hn = nStatus.h;
	var t0 = tn - dT;
	var d0;
	if (e == Number.POSITIVE_INFINITY) {
		d0 = dn;
	} else {
		d0 = (1.006 * t0 + e * dn - hn) / (e - 2501 - 1.86 * t0);
	}
	var res = Calcu_04(t0, d0, atm);//如果rh=nan，说明温差过大

	if (res.rh == 'NaN' || res.rh > 90) {
		//这个不对
		var res2 = this.calcL2status(nStatus, e);
		var dTmax = tn - res2.t;
		var res = { errType: 'ERROR', desc: '温差过大，无法继续进行,最大温差为：' + dTmax, dTmax: dTmax }
		alert('calcOstatus:', res.desc);
		console.log(res)
		return res;
	} else {
		return res;
	}
}
//送风状态点(室内状态点，湿度差,焓湿比)
function calcOstatus2(nStatus, q, w, g, atm) {
	var tn = nStatus.t;
	var dn = nStatus.d;
	var hn = nStatus.h;
	var dD = w / g;//dn-do
	var e = calcE(q, w)
	var h0;
	if (e == Number.POSITIVE_INFINITY) {
		h0 = hn + q / g
	} else {
		h0 = -dD * e + hn;
	}
	var d0 = dn - dD;
	var res = Calcu_45(d0, h0, atm);
	return res;
}
//计算热湿比线与相对湿度90%的交点（机器露点）
function calcL2status(nStatus, e, lRh, atm) {
	var tn = nStatus.t;
	var dn = nStatus.d;
	var hn = nStatus.h;
	var res;
	if (e == Number.POSITIVE_INFINITY) {
		res = Calcu_24(lRh, dn, atm);
	} else {
		//迭代求解
		var eps = 0.1;
		var t1 = tn;
		var t2 = -50;//这也意味着这个函数只能求解到-50摄氏度
		do {
			var t3 = (t1 + t2) / 2;
			var d3 = (1.006 * t3 + e * dn - hn) / (e - 2501 - 1.86 * t3);
			res = Calcu_04(t3, d3, atm);
			if (res.rh > lRh || res.rh == 'NaN') {
				t2 = t3;
			} else {
				t1 = t3;
			}
		} while (Math.abs(t1 - t2) > eps);
	}
	return res;
}
//计算送风量(这个函数，不是十分需要啊)
function calcG(q, dh) {
	return Math.abs(q / dh);
}
//计算处理过程的热量
function calcQ(g, h1, h2) {
	return Math.abs(g * (h1 - h2));
}
//计算混合点
function calcC(rat, nStatus, wStatus, atm) {
	var h = rat * (wStatus.h - nStatus.h) + nStatus.h;
	var d = rat * (wStatus.d - nStatus.d) + nStatus.d;
	return Calcu_45(d, h, atm)
}
//计算混合点方法2
function calcC2(h3, nStatus, wStatus, atm) {
	var d3 = nStatus.d + (h3 - nStatus.h) * (nStatus.d - wStatus.d) / (nStatus.h - wStatus.h);
	return Calcu_45(d3, h3, atm)
}
//计算混合点方法3
function calcC3(d3, nStatus, wStatus, atm) {
	var h3 = nStatus.h + (d3 - nStatus.d) * (nStatus.h - wStatus.h) / (nStatus.d - wStatus.d);
	return Calcu_45(d3, h3, atm)
}
function calcRat(wStatus, nStatus, cStatus) {
	var rat = (cStatus.h - nStatus.h) / (wStatus.h - nStatus.h);
	if (rat > 1 || rat < 0) {
		alert('calcRat函数出错，结果不合法，请终止计算');
		console.log('calcRat函数出错，结果不合法，请终止计算', rat)
	}
	return rat;
}
exports.Calcu_01 = Calcu_01;
exports.Calcu_02 = Calcu_02;
exports.Calcu_03 = Calcu_03;
exports.Calcu_04 = Calcu_04;
exports.Calcu_05 = Calcu_05;
exports.Calcu_06 = Calcu_06;

exports.Calcu_12 = Calcu_12;
exports.Calcu_13 = Calcu_13;
exports.Calcu_14 = Calcu_14;
exports.Calcu_16 = Calcu_16;

exports.Calcu_23 = Calcu_23;
exports.Calcu_24 = Calcu_24;
exports.Calcu_25 = Calcu_25;
exports.Calcu_26 = Calcu_26;

exports.Calcu_35 = Calcu_35;
exports.Calcu_45 = Calcu_45;
exports.Calcu_56 = Calcu_56;
exports.calcE = calcE;
exports.calcOstatus = calcOstatus;
exports.calcOstatus2 = calcOstatus2;
exports.calcL2status = calcL2status;
exports.calcG = calcG;
exports.calcQ = calcQ;
exports.calcC = calcC;
exports.calcC2 = calcC2;
exports.calcC3 = calcC3;
exports.calcRat = calcRat;



// WEBPACK FOOTER //
// ./src/vue/chart/EHcore.js